<template>
  <div>

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
          class="input form-control"
          @keypress.enter="find()"
          v-model="query.generic"
          placeholder="Pesquisar por code, name ou description"
        >
        <search-icon @click="find()" class="icon icon-within"/>
      </div>

      <button
        class="col-md-2 ml-2 btn-sm btn-outline"
        :class="{ 'btn-outline-active': showFilter }"
        @click="showFilter = !showFilter"
      >
        Filtros
        <chevron-down-icon class="fa-angle-right" :class="{ 'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQueryAndHasNumberOfBadges" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>

    <!-- Badges -->
    <div class="row">
      <div class="col-md-12">
        <BadgeFilters
          :query="query"
          @clearBadge="find()"
          @clearAllBadges="find()"
          :amount-changed="updateNumberOfBadges"
          :filters="badgeFilters"
        />
      </div>
    </div>

    <!-- Filters -->
    <template v-if="showFilter">
      <div class="row mt-4">
        <div class="col-md-4">
          <label for="type-period">Tipo do período</label>
          <select v-model="query.periodType" id="type-period" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="start-date">Data inicial</label>
          <input v-model="query.startDate" type="date" id="start-date" class="form-control">
        </div>

        <div class="col-md-4">
          <label for="end-date">Data final</label>
          <input v-model="query.endDate" type="date" id="end-date" class="form-control">
        </div>
      </div>
    </template>

    <hr>

    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>

        <div class="float-right" style="display: inline-flex;align-items: center;">
          <small class="mr-2" style="white-space: nowrap">Ordenar por:</small>
          <select v-model="orderBy" class="browser-default custom-select">
            <option value="created_at">Data de criação</option>
            <option value="updated_at">Data de atualização</option>
            <option value="name">Nome</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>Name</th>
              <th>Description</th>
              <th>Friendly name</th>
              <th>Friendly description</th>
              <th>Created by</th>
              <th>Updated by</th>
              <th>Created at</th>
              <th>Updated at</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="entityStatus in entityStatuses" :key="entityStatus.id">
              <td>{{ entityStatus.id }}</td>
              <td>{{ entityStatus.code }}</td>
              <td>{{ entityStatus.name }}</td>
              <td>{{ entityStatus.description }}</td>
              <td>{{ entityStatus.friendlyName }}</td>
              <td>{{ entityStatus.friendlyDescription }}</td>
              <td>{{ entityStatus.createdBy }}</td>
              <td>{{ entityStatus.updatedBy }}</td>
              <td>{{ entityStatus.createdAt | datetime }}</td>
              <td>{{ entityStatus.updatedAt | datetime }}</td>
              <td>
                <button class="btn btn-outline" @click="editEntityStatus(entityStatus)">
                  Editar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <Modal v-model="showEditModal" width="md">
      <div slot="header">
        <h3>Editar Entity Status</h3>
      </div>
      <div v-if="currentEntityStatus" class="entity-status-form">
        <div class="form-group">
          <label>Código</label>
          <input disabled v-model="currentEntityStatus.code" class="form-control" />
        </div>
        <div class="form-group">
          <label>Nome</label>
          <input v-model="currentEntityStatus.name" class="form-control" />
        </div>
        <div class="form-group">
          <label>Nome Amigável</label>
          <input v-model="currentEntityStatus.friendlyName" class="form-control" />
        </div>
        <div class="form-group">
          <label>Descrição</label>
          <textarea v-model="currentEntityStatus.description" class="form-control" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label>Descrição Amigável</label>
          <textarea v-model="currentEntityStatus.friendlyDescription" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <template slot="footer">
        <button @click="showEditModal = false" class="btn btn-outline mr-2">Cancelar</button>
        <button @click="saveEntityStatus" class="btn btn-primary">Salvar</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import Modal from '@/components/shares/specialTag/Modal'
import ModelMapper from '@/mixins/ModelMapper'
import Pagination from '@/components/shares/specialTag/Pagination'
import EntityProxy from '@/models/EntityProxy'

import { Filter } from '@/models/filter'
import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'

export default {
  components: { BadgeFilters, ChevronDownIcon, Modal, Pagination, SearchIcon },
  computed: {
    currentAxios() {
      return this.axios.v3
    },
    entityStatuses() {
      return this.getModels || []
    },
    badgeFilters() {
      return [
        this.filterId,
        this.filterCode,
        this.filterFriendlyName,
        this.filterEndDate,
        this.filterStartDate
      ]
    }
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.defaultModelSetting.updateQueryURL = true
    this.addOrderBy(this.orderBy, 'desc')
    this.loadFilters()
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentEntityStatus: null,
    showEditModal: false,
    filterId: null,
    filterCode: null,
    filterFriendlyName: null,
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    modelPathPrefix: 'admin',
    nameModel: 'EntityStatus',
    orderBy: 'created_at'
  }),
  methods: {
    editEntityStatus(entityStatus) {
      this.currentEntityStatus = EntityProxy.clone(entityStatus)
      this.showEditModal = true
    },
    find() {
      this.asyncTemplateSelect()
    },
    saveEntityStatus() {
      const { id, name, description, friendlyName, friendlyDescription } = this.currentEntityStatus
      const data = this.$parse.toSnakecase({ name, description, friendlyName, friendlyDescription })
      this.axios.v3.patch(`admin/entity_statuses/${id}`, data)
        .then(() => {
          this.$notify.add('Entity Status atualizado com sucesso!')
          this.showEditModal = false
          this.$ls.remove('admin/entity_statuses/all')
          this.loadFilters()
          this.find()
        })
        .catch(e => this.$notify.addError(e))
    },
    async loadFilters() {
      const key = 'admin/entity_statuses/all'
      const mount = (data) => {
        this.filterId = new Filter({
          key: 'id',
          label: 'ID',
          table: data
            .map(es => [String(es.id), String(es.id)])
            .sort((a, b) => Number(a[1]) - Number(b[1]))
        })
        this.filterCode = new Filter({
          key: 'code',
          label: 'Code',
          table: this.uniquePairs(data, 'code')
        })
        this.filterFriendlyName = new Filter({
          key: 'friendlyName',
          label: 'Friendly name',
          table: this.uniquePairs(data, 'friendly_name')
        })
      }

      const cached = this.$ls.get(key)
      if (cached)
        return mount(cached)

      try {
        const response = await this.axios.v3.get('admin/entity_statuses', {
          params: { per_page: 1000 }
        })
        const data = response.data || []
        mount(data)
        this.$ls.set(key, data, { minutes: 5 })
      } catch (e) {
        this.$notify.addError(e)
      }
    },
    uniquePairs(data, field) {
      const values = [...new Set(data.map(d => d[field]).filter(Boolean))]
      values.sort((a, b) => String(a).localeCompare(String(b)))
      return values.map(v => [v, v])
    }
  },
  mixins: [ModelMapper],
  name: 'AdminEntityStatusesIndex',
  watch: {
    orderBy(newValue, oldValue) {
      if (newValue === oldValue) return

      this.order = []
      this.addOrderBy(newValue, 'desc')
      this.find()
    }
  }
}
</script>

<style scoped lang="scss">
.fa-angle-right {
  transition: transform .2s;
  margin-left: 8px;
}

.rotate-90 {
  transform: rotate(90deg);
}

.entity-status-form label {
  color: var(--primary-text-color);
}

.entity-status-form .form-control {
  background-color: var(--card-bg);
  border-color: var(--border-color);
  color: var(--primary-text-color);
}

.entity-status-form .form-control:disabled {
  background-color: var(--light-gray);
  color: var(--secondary-text-color);
  opacity: 0.6;
  cursor: not-allowed;
}

.entity-status-form .form-control:focus {
  border-color: var(--primary-color);
}
</style>
